import { Link } from "@inertiajs/react";
import ReferencesSectionCard from "./ReferencesSectionCard";

export default function ReferencesSectionsList({ referencesSections }: any) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        width: "100%",
      }}
    >
      <section>
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fill, minmax(min(100%, 500px), 1fr))",
            gap: "12px",
          }}
        >
          {referencesSections.map((referencesSection: any) => (
            <ReferencesSectionCard referencesSection={referencesSection} />
          ))}
        </div>
      </section>
      <div
        style={{
          textAlign: "center",
        }}
      >
        <Link href={"/references"}>
          <button className="btn btn-primary btn-sm">Reference Page</button>
        </Link>
      </div>
    </div>
  );
}
